import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import {
  getChecklistBeforeIndicatorAvailableColumns,
  getChecklistBeforeIndicatorListAll,
  getDefects,
  getRoomTypes,
  getZones,
} from './api';

export const path = '/checklist/before/indicator/list';

const PageChecklistBeforeIndicatorList: React.FC = (props) => {
  const ChecklistBeforeIndicatorList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getChecklistBeforeIndicatorAvailableColumns,
      defects: getDefects,
      indicators: getChecklistBeforeIndicatorListAll,
      roomTypes: getRoomTypes,
      zones: getZones,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ChecklistBeforeIndicatorList {...props} />;
};

export default PageChecklistBeforeIndicatorList;
